import ChartColorService from "../../Services/Shared/ChartColor.service";
export default class WorkflowNodeStatusDomainService {
    static get Unfulfilled() {
        return {
            id: 2,
            name: "Pending",
        };
    }
    static get Fulfilled() {
        return {
            id: 3,
            name: "Fulfilled",
        };
    }
    static get Failed() {
        return {
            id: 4,
            name: "Failed",
        };
    }
    static get Cancelled() {
        return {
            id: 5,
            name: "Cancelled",
        };
    }
    static get Creating() {
        return {
            id: 6,
            name: "Creating",
        };
    }
    static get Statuses() {
        return [
            WorkflowNodeStatusDomainService.Unfulfilled,
            WorkflowNodeStatusDomainService.Fulfilled,
            WorkflowNodeStatusDomainService.Failed,
            WorkflowNodeStatusDomainService.Cancelled,
            WorkflowNodeStatusDomainService.Creating,
        ];
    }
    static getFromId(id) {
        return WorkflowNodeStatusDomainService.Statuses.find((status) => status.id === id);
    }
    static getBootstrapColor(id) {
        const BADGE_MAPPING = {
            [WorkflowNodeStatusDomainService.Unfulfilled.id]: "secondary",
            [WorkflowNodeStatusDomainService.Fulfilled.id]: "success",
            [WorkflowNodeStatusDomainService.Failed.id]: "danger",
            [WorkflowNodeStatusDomainService.Cancelled.id]: "secondary",
            [WorkflowNodeStatusDomainService.Creating.id]: "secondary",
        };
        return BADGE_MAPPING[id] || "secondary";
    }
    static getChartColor(id) {
        const BADGE_MAPPING = {
            [WorkflowNodeStatusDomainService.Unfulfilled.id]: ChartColorService.Gray,
            [WorkflowNodeStatusDomainService.Fulfilled.id]: ChartColorService.Green,
            [WorkflowNodeStatusDomainService.Failed.id]: ChartColorService.Red,
            [WorkflowNodeStatusDomainService.Cancelled.id]: ChartColorService.Orange,
            [WorkflowNodeStatusDomainService.Creating.id]: ChartColorService.Purple,
        };
        return BADGE_MAPPING[id] || ChartColorService.Gray;
    }
}
